import { render } from "./WxAuth.vue?vue&type=template&id=04ce47a0&scoped=true"
import script from "./WxAuth.vue?vue&type=script&lang=js"
export * from "./WxAuth.vue?vue&type=script&lang=js"

import "./WxAuth.vue?vue&type=style&index=0&id=04ce47a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ce47a0"]])

export default __exports__